const GS = String.fromCharCode(29);
const GS_MARKER_RE = /<\s*(?:GS|XH|0x1D)\s*>/gi;
const CRYPTO_TAIL_RE = /91[\s\S]{4}92[\s\S]{44}$/;

export async function copyKizText(value = "") {
  const text = String(value || "").trim();
  if (!text) return;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }
  } catch (e) {
    // Fallback to a hidden textarea when Clipboard API is unavailable.
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "readonly");
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

export function normalizeKizInput(raw = "") {
  const code = String(raw || "").trim().replace(GS_MARKER_RE, GS);
  const normalizedPrefix = code
    .replace(/^\(01\)/, "01")
    .replace(/^(01\d{14})\(21\)/, (_, prefix) => `${prefix}21`);

  // Parentheses mark AIs in the human-readable form, not data characters.
  return /^01\d{14}21/.test(normalizedPrefix)
    ? normalizedPrefix.replace(/\((91|92|93)\)/g, (_, ai) => ai)
    : normalizedPrefix;
}

export function getKizValidationError(raw = "") {
  const code = normalizeKizInput(raw);
  if (!code) return "Введите КИЗ";
  if (/[А-Яа-яЁё]/.test(code)) return "Переключите язык ввода";
  if (!/^01\d{14}21/.test(code)) {
    return "КИЗ должен начинаться с 01, 14 цифр GTIN и 21";
  }
  // Serial and verification fields vary by product group. Only reject a missing
  // serial here; a fixed total length would reject legitimate marking formats.
  if (!code.slice(18).replaceAll(GS, "")) return "КИЗ неполный: нет серийного номера";
  return "";
}

// Short KIZ is the GTIN + serial part; AI 91/92 is the cryptographic tail.
export function getShortKiz(full = "") {
  const code = String(full || "").trim();
  if (!code) return "";

  const normalized = code.replace(GS_MARKER_RE, GS);
  const firstGsIndex = normalized.indexOf(GS);
  if (firstGsIndex >= 0) {
    const suffix = normalized.slice(firstGsIndex + 1);
    return suffix.startsWith("91") ? normalized.slice(0, firstGsIndex) : normalized;
  }

  const cryptoTailMatch = normalized.match(CRYPTO_TAIL_RE);
  if (cryptoTailMatch?.index > 0) {
    return normalized.slice(0, cryptoTailMatch.index);
  }

  // Keep compatibility with codes that contain only the visible AI 91 marker.
  const legacyMarkerIndex = normalized.indexOf("91EE");
  return legacyMarkerIndex > 0 ? normalized.slice(0, legacyMarkerIndex) : normalized;
}
